import { render, staticRenderFns } from "./iDSResetPwd.vue?vue&type=template&id=b8335d66"
import script from "./iDSResetPwd.vue?vue&type=script&lang=js"
export * from "./iDSResetPwd.vue?vue&type=script&lang=js"
import style0 from "./iDSResetPwd.vue?vue&type=style&index=0&id=b8335d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports